export default "__VITE_ASSET__BgP6J9HF__"